var hasNumber = function (val) {
    return /\d/.test(val);
};
export default hasNumber;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/hasNumber.js